export { default } from './SearchPrintList';



// WEBPACK FOOTER //
// ./app/components/search/SearchPrintList/index.js